import React from "react";

export default function Footer() {
  return (
    <footer className="relative bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <svg width="24" height="24" viewBox="0 0 28 28" fill="none" className="text-[#FF4500]">
                <circle cx="14" cy="14" r="12.5" stroke="currentColor" strokeWidth="1.2" />
                <circle cx="14" cy="14" r="5" stroke="currentColor" strokeWidth="1.2" />
                <line x1="14" y1="0" x2="14" y2="28" stroke="currentColor" strokeWidth="1" />
                <line x1="0" y1="14" x2="28" y2="14" stroke="currentColor" strokeWidth="1" />
                <circle cx="14" cy="14" r="1.4" fill="currentColor" />
              </svg>
              <div className="font-display font-black text-white text-[15px] tracking-tight leading-none">
                AERIAL <span className="text-[#FF4500]">ALIGNMENT</span>
              </div>
            </div>
            <p className="text-white/55 text-[14px] leading-relaxed max-w-md">
              Precision surveying, construction layout, rail layout and drone services
              along the US East Coast. Built on NAVD88, held to ALTA/NSPS and FAA Part 107.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="label-mono mb-4">Disciplines</div>
            <ul className="space-y-2 font-display font-medium text-white/75 text-[14px]">
              <li>Construction Layout</li>
              <li>Rail Layout</li>
              <li>Conventional Surveying</li>
              <li>Drone Services</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-mono mb-4">Contact</div>
            <ul className="space-y-2 text-[14px]">
              <li>
                <a href="tel:5165028172" className="text-white hover:text-[#FF4500] font-display font-bold">
                  516.502.8172
                </a>
              </li>
              <li>
                <a href="mailto:office@aerialalignment.com" className="text-white hover:text-[#FF4500] font-display font-bold break-all">
                  office@aerialalignment.com
                </a>
              </li>
              <li className="font-mono text-[12px] text-white/50">
                Hub · Philadelphia, PA · 39.9526°N 75.1652°W
              </li>
              <li className="font-mono text-[12px] text-white/50">
                Service: Virginia → Maine
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/40">
            © {new Date().getFullYear()} Aerial Alignment · All rights reserved
          </div>
          <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/40">
            NAVD88 · ALTA/NSPS · FAA Part 107
          </div>
        </div>
      </div>
    </footer>
  );
}
